import { END_POINTS } from "../constants/url";
import { CommonBody } from "../types/General";
import emptySplitApi from "../utils/rtk";

type CommonResponseType = {
  statusCode: number;
  message: string;
  data: any;
  body: any;
};
export interface notification {
  title: string;
  message: string;
  role: number;
  type: number;
}
export interface Notification {
  title: string;
  message: string;
  _id: string;
  role: number;
  notificationType?: number;
  createdAt: string;
}

export interface NotificationResponse {
  title: string;
  createdAt(createdAt: any, arg1: string): unknown;
  message: string;
  image: string;
  _id: string;
  data: {
    notificationData: Notification[];
    totalNotification: number;
  };
}

export const notificationsApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    addNotification: builder.mutation<
      CommonResponseType & { data: notification },
      any
    >({
      query: (body) => ({
        url: END_POINTS.notification,
        method: "POST",
        body,
      }),
    }),

    getNotification: builder.query<
      CommonResponseType & { data: any },
      {
        page: number;
        limit: number;
        search: string;
        type: number;
        filterType?: number;
        role?: number;
      }
    >({
      query: ({ page, limit, search, type, filterType, role }) => ({
        url: `${END_POINTS.notification}?page=${page}&limit=${limit}&search=${search}&type=${type}${filterType ? `&filterType=${filterType}` : ''}${role ? `&role=${role}` : ''}`,
        method: "GET",
      }),
    }),
    getHeaderNotification: builder.query<
      CommonResponseType & { data: NotificationResponse },
      {
        page: number;
        limit: number;
        search: string;
        type: number;
      }
    >({
      query: ({ type, page, limit, search }) => ({
        url: `${END_POINTS.notification}?page=${page}&limit=${limit}&search=${search}&type=${type}`,
        method: "GET",
      }),
    }),

    deleteNotificationById: builder.mutation<
      CommonResponseType,
      { id: string }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.notification}/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useAddNotificationMutation,
  useLazyGetNotificationQuery,
  useDeleteNotificationByIdMutation,
  useLazyGetHeaderNotificationQuery,
} = notificationsApi;
